import { CLEAR_VIDEO_STATE, VIDEO_FETCH_VIDEO_DATA, VIDEO_SEARCH_VIDEO_DATA } from '../constants/video';
import { FAIL, START, SUCCESS } from '../constants';
import type { TDispatch } from '../types/core';
import { addJavaHeaders } from '../utils';

export const startFetchingVideoData = () => ({ type: VIDEO_FETCH_VIDEO_DATA + START });

export const setVideoData = (videoData, slug) => ({
	type: VIDEO_FETCH_VIDEO_DATA + SUCCESS,
	payload: { videoData, slug },
});

export const fetchingVideoDataError = () => ({ type: VIDEO_FETCH_VIDEO_DATA + FAIL });

export const getVideoContent =
	(page: number = 0, category: string = null) =>
	async (dispatch: TDispatch, getState, { fetch }) => {
		const {
			token: { token = '' } = {},
			city: { cityIds = [] },
			video: { categorySlug = null },
		} = getState();

		if (category !== categorySlug) {
			dispatch({ type: CLEAR_VIDEO_STATE });
		}

		dispatch(startFetchingVideoData());

		const contentUrl = '/lexsApi/content/video/list';
		const count = 24;

		const fetchOptions = {
			method: 'POST',
			body: JSON.stringify({ cityIds, page, count, categorySlug: category }),
			...addJavaHeaders(token),
		};

		return fetch(contentUrl, fetchOptions)
			.then((data) => data.json())
			.then(({ data }) => {
				dispatch(setVideoData(data, category));
			})
			.catch((e) => {
				dispatch(fetchingVideoDataError());
				console.error(e);
			});
	};

export const searchVideoContent =
	(searchString) =>
	async (dispatch: TDispatch, getState, { fetch }) => {
		const { token: { token = '' } = {} } = getState();
		dispatch({ type: CLEAR_VIDEO_STATE });
		dispatch({ type: VIDEO_SEARCH_VIDEO_DATA + START });

		const contentUrl = '/lexsApi/search/content';

		const fetchOptions = {
			method: 'POST',
			body: JSON.stringify({ type: 'video', searchString }),
			...addJavaHeaders(token),
		};

		return fetch(contentUrl, fetchOptions)
			.then((data) => data.json())
			.then(({ data }) => {
				dispatch({ type: VIDEO_SEARCH_VIDEO_DATA + SUCCESS, payload: data.items });
			})
			.catch((e) => {
				dispatch({ type: VIDEO_SEARCH_VIDEO_DATA + FAIL });
				console.error(e);
			});
	};
